"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const color = require("color");
const isIE = !!document.documentMode;
exports.default = (theme) => (0, styles_1.createStyles)({
    carouselSection: {
        padding: 0
    },
    carouselImageContainer: {
        [theme.breakpoints.down('xs')]: {
            paddingBottom: '24px !important'
        }
    },
    carouselData: {
        [theme.breakpoints.down('xs')]: {
            paddingTop: '0 !important'
        }
    },
    carouselContainer: {
        display: 'flex',
        padding: 0,
        maxWidth: '100% !important',
        '& .slick-dots': {
            [theme.breakpoints.up('lg')]: {
                position: 'relative'
            },
            [theme.breakpoints.down('lg')]: {
                paddingBottom: '0rem'
            },
            [theme.breakpoints.down('md')]: {
                paddingBottom: '1rem',
                position: 'relative'
            },
            [theme.breakpoints.down('xs')]: {
                paddingBottom: '1rem',
                position: 'relative'
            }
        },
        '& .slick-dots li button::before': {
            backgroundColor: 'rgba(0, 0, 0, 0.54)',
            borderRadius: '10px'
        },
        '& button.slick-arrow': {
            top: '80%',
            [theme.breakpoints.down('md')]: {
                top: '70%'
            },
            [theme.breakpoints.down('xs')]: {
                top: '63%'
            },
            opacity: 1,
            height: '0%'
        },
        '& .slick-next::before, & .slick-prev::before': {
            color: color(theme.palette.common.black).alpha(0.54).rgb().string()
        },
        '& .slick-dots li.slick-active button:before': {
            backgroundColor: theme.palette.secondary.dark
        },
        '& .slick-list': {
            display: 'list-item'
        }
    },
    carouselImage: {
        height: '585px',
        objectFit: 'cover',
        [theme.breakpoints.down('xs')]: {
            height: '400px'
        },
        opacity: isIE ? 0.1 : 1
    },
    carouselContent: {
        position: `absolute`,
        left: 0,
        right: 0,
        top: 0,
        bottom: 172,
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            bottom: 61
        }
    },
    carouselInnerContainer: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    carouselGrid: {
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column-reverse'
        }
    },
    carouselDescriptionBtnView: {
        display: 'flex',
        alignItems: 'flex-start',
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
            '& button': {
                width: '100%'
            }
        }
    },
    marginAuto: {
        marginLeft: 'auto !important',
        marginRight: 'auto !important'
    }
});
//# sourceMappingURL=VirtualTourStyle.js.map